module.exports = __webpack_public_path__ + "img/1XSTAVKA.99f558b9.svg";